import toast from "react-hot-toast";
import { webPaths } from "../../routes/pageRoutes";
import { handleShareAsset, pipGetAccessToken } from "../../utils/pip";
import { useLocation, useNavigate } from "react-router-dom";

const AssetCard = ({ data = {} }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();


  return (
    <>
      <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-5 pb-3">
        <figure
          class={`ct_assets_card ${pathname != webPaths?.WebHome ? "" : ""}`}
        >
          <div class="ct_assets_img">
            {data?.promote != 0 && (
              <div class="ct_featured_btn">
                <i class="fa-solid fa-bolt"></i>
                Featured
              </div>
            )}
            <div className="position-relative">
              <img
                src={
                  data?.AssetImages
                    ? data?.AssetImages[0]?.image_url
                    : "/assets/img/assets_1.png"
                }
                alt="img"
              />
              {data?.status && (
                <div class="ct_stolen_text_bg">
                  <p class="mb-0">{data?.status}</p>
                </div>
              )}
            </div>

            {data?.lock == 0 ? (
              <div className="ct_lock_icon1">
                <svg
                  width="20"
                  height="28"
                  viewBox="0 0 20 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.3333 12.3125H16.6667V7.25C16.6667 3.5375 13.6667 0.5 10 0.5C6.33333 0.5 3.33333 3.5375 3.33333 7.25V12.3125H1.66667C0.833333 12.3125 0 13.1562 0 14V25.8125C0 26.6562 0.833333 27.5 1.66667 27.5H18.3333C19.1667 27.5 20 26.6562 20 25.8125V14C20 13.1562 19.1667 12.3125 18.3333 12.3125ZM11.6667 24.125H8.33333L9 20.4125C8.16667 20.075 7.5 19.0625 7.5 18.2188C7.5 16.8687 8.66667 15.6875 10 15.6875C11.3333 15.6875 12.5 16.8687 12.5 18.2188C12.5 19.2313 12 20.075 11 20.4125L11.6667 24.125ZM13.3333 12.3125H6.66667V7.25C6.66667 5.39375 8.16667 3.875 10 3.875C11.8333 3.875 13.3333 5.39375 13.3333 7.25V12.3125Z"
                    fill="#32CD30"
                  />
                </svg>
              </div>
            ) : (
              <div className="ct_lock_icon1">
                <svg
                  width="21"
                  height="28"
                  viewBox="0 0 21 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.6 11.9V6.8C13.6 4.93 12.07 3.4 10.2 3.4C8.33 3.4 6.8 4.93 6.8 6.8H3.4C3.4 3.043 6.443 0 10.2 0C13.957 0 17 3.043 17 6.8V11.9H18.7C19.635 11.9 20.4 12.665 20.4 13.6V25.5C20.4 26.435 19.635 27.2 18.7 27.2H1.7C0.764999 27.2 0 26.435 0 25.5V13.6C0 12.665 0.764999 11.9 1.7 11.9H13.6ZM11.9 23.8L11.288 20.145C12.155 19.737 12.75 18.87 12.75 17.85C12.75 16.439 11.611 15.3 10.2 15.3C8.789 15.3 7.65 16.439 7.65 17.85C7.65 18.87 8.245 19.737 9.112 20.145L8.5 23.8H11.9Z"
                    fill="#32CD30"
                  />
                </svg>
              </div>
            )}
          </div>
          <figcaption>
            <div class="d-flex align-items-center gap-2 justify-content-between">
              <h4 className="mb-0 text-capitalize">
                {/* {data?.isStolen && ( */}
                {data?.lock == 0 ? (
                  <svg
                    className="me-2"
                    width="18"
                    height="17"
                    viewBox="0 0 18 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.98283 0C7.82833 0 7.72532 0.0818013 7.64807 0.184053L0.0772532 14.1107C0.0257511 14.213 0 14.3766 0 14.4993V16.1558C0 16.258 0.103004 16.3398 0.23176 16.3398H17.7682C17.897 16.3398 18 16.258 18 16.1558V14.4993C18 14.397 17.9742 14.213 17.9227 14.1107L10.3519 0.184053C10.3004 0.0818013 10.1717 0 10.0172 0H7.93133L7.98283 0ZM7.75107 6.1351H10.3262V10.2252H7.75107V6.1351ZM7.75107 12.2702H10.3262V14.3152H7.75107V12.2702Z"
                      fill="#FCCA00"
                    />
                  </svg>
                ) : null}
                {/* )} */}
                {data?.AssetName || "#N/A"}
              </h4>
              <h3 class="ct_fs_15 mb-0">UIC: {data?.UIC}</h3>
            </div>
            <p
              class="mb-0 opacity-50 ct_para_scroll ct_custom_scroll"
              style={{ maxHeight: "70px" }}
            >
              {data?.AssetDetails || "#N/A"}
            </p>
          </figcaption>
          <div className="mt-auto" style={{ paddingInline: "5px" }}>
            {pathname != webPaths?.MyAssets && (
              <div class="d-flex align-items-center justify-content-between gap-2 ct_mt_20">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    // const { token } = pipGetAccessToken();
                    // if (!token) {
                    //   return navigate(webPaths?.Login);
                    // }
                    navigate(`/assets-detail/${data?.id}`, {
                      state: { from: pathname },
                    });
                  }}
                  class="ct_custom_btn_2 ct_border_radius_10 ct_py_6"
                >
                  View Asset
                </a>
                <div className="d-flex align-items-center gap-3">
                  <a
                    target="_blank"
                    href={`https://www.google.com/maps?q=${data?.latitude},${data?.longitude}`}
                    // onClick={(e) => {
                    //   e.preventDefault();
                    // }}
                  >
                    <svg
                      width="18"
                      height="26"
                      viewBox="0 0 18 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 0C6.61305 0 4.32387 0.948211 2.63604 2.63604C0.948211 4.32387 0 6.61305 0 9C0 15.75 9 25.7143 9 25.7143C9 25.7143 18 15.75 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948211 11.3869 0 9 0ZM9 12.2143C8.36427 12.2143 7.74283 12.0258 7.21424 11.6726C6.68565 11.3194 6.27367 10.8174 6.03039 10.2301C5.78711 9.64272 5.72345 8.99643 5.84748 8.37292C5.9715 7.74941 6.27763 7.17668 6.72716 6.72716C7.17668 6.27763 7.74941 5.9715 8.37292 5.84748C8.99643 5.72345 9.64272 5.78711 10.2301 6.03039C10.8174 6.27367 11.3194 6.68565 11.6726 7.21424C12.0258 7.74283 12.2143 8.36427 12.2143 9C12.2143 9.42211 12.1311 9.84008 11.9696 10.2301C11.8081 10.62 11.5713 10.9744 11.2728 11.2728C10.9744 11.5713 10.62 11.8081 10.2301 11.9696C9.84008 12.1311 9.42211 12.2143 9 12.2143Z"
                        fill="#585858"
                      />
                    </svg>
                  </a>
                  <a
                    onClick={() => {
                      handleShareAsset(data?.id);
                    }}
                    class="ct_text_clr_4B5563 d-flex align-items-center"
                    // data-bs-target="#mobileAppModal"
                    // data-bs-toggle="modal"
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_995_1878)">
                        <path
                          d="M11.6447 0C11.812 0.0836476 11.9481 0.182475 12.0932 0.298096C12.1197 0.319033 12.1462 0.33997 12.1735 0.361542C12.3746 0.52159 12.5711 0.686716 12.7664 0.853909C12.9334 0.99631 13.1042 1.13291 13.2776 1.26758C13.4988 1.43949 13.7138 1.61708 13.9266 1.79932C14.0936 1.94167 14.2644 2.07825 14.4377 2.21289C14.6589 2.3848 14.874 2.56239 15.0868 2.74463C15.2538 2.88698 15.4246 3.02356 15.5979 3.1582C15.8191 3.33011 16.0341 3.50771 16.2469 3.68994C16.4139 3.83229 16.5847 3.96887 16.758 4.10352C16.9793 4.27543 17.1943 4.45302 17.4071 4.63525C17.5741 4.77761 17.7449 4.91418 17.9182 5.04883C18.1394 5.22074 18.3545 5.39833 18.5672 5.58057C18.7343 5.72292 18.9051 5.8595 19.0783 5.99414C19.3034 6.16907 19.5225 6.34964 19.7393 6.53475C19.911 6.68125 20.0858 6.82318 20.2627 6.96346C20.4117 7.08216 20.5588 7.20317 20.7061 7.32399C20.8649 7.45412 21.0244 7.58348 21.1838 7.71289C21.4565 7.93426 21.7286 8.15623 22.0002 8.37891C21.935 8.54277 21.8393 8.62265 21.7021 8.73071C21.6596 8.76456 21.6171 8.7984 21.5734 8.83327C21.5082 8.88486 21.5082 8.88486 21.4416 8.9375C21.3627 9.0018 21.2839 9.06625 21.2053 9.13086C18.842 11.0645 18.842 11.0645 18.723 11.1618C18.647 11.224 18.571 11.2862 18.4951 11.3484C18.2305 11.5652 17.9652 11.781 17.6997 11.9966C17.4569 12.1937 17.2148 12.3916 16.9729 12.5898C16.8941 12.6543 16.8153 12.7188 16.7365 12.7832C16.6975 12.8151 16.6585 12.847 16.6184 12.8799C13.4279 15.4902 13.4279 15.4902 13.3089 15.5876C13.2329 15.6498 13.157 15.712 13.081 15.7742C12.9604 15.873 12.8397 15.9717 12.719 16.0703C12.6918 16.0925 12.6647 16.1147 12.6367 16.1376C12.5469 16.211 12.457 16.2844 12.3672 16.3577C12.3391 16.3806 12.311 16.4036 12.2821 16.4273C11.718 16.8867 11.718 16.8867 11.6447 16.8867C11.6447 15.171 11.6447 13.4552 11.6447 11.6875C10.0729 11.884 8.59729 12.1471 7.17599 12.8477C7.13513 12.8676 7.09428 12.8875 7.05218 12.9081C6.4283 13.2149 5.84488 13.552 5.28536 13.9648C5.25835 13.9846 5.23135 14.0044 5.20352 14.0248C4.92102 14.2329 4.65278 14.4539 4.3946 14.6916C4.30449 14.7744 4.2127 14.8546 4.11984 14.9343C2.68136 16.1905 1.81616 17.8829 1.08248 19.6099C1.03839 19.7132 0.994271 19.8165 0.950136 19.9199C0.701915 20.5008 0.701914 20.5008 0.45738 21.0833C0.424413 21.1627 0.391326 21.2419 0.358238 21.3212C0.316951 21.4202 0.275899 21.5194 0.23511 21.6186C0.216765 21.6625 0.198421 21.7064 0.17952 21.7517C0.155493 21.8098 0.155492 21.8098 0.130979 21.8691C0.0861445 21.957 0.0861452 21.957 0.000207657 22C-0.00282671 21.3014 -0.00508749 20.6029 -0.00647081 19.9043C-0.00713066 19.5798 -0.00802788 19.2554 -0.00951696 18.9309C-0.0108168 18.6475 -0.0116366 18.3641 -0.0119206 18.0808C-0.0120861 17.9312 -0.0124654 17.7817 -0.013422 17.6322C-0.0347776 14.1528 1.31359 11.0624 3.73849 8.59375C3.84907 8.48794 3.96437 8.39048 4.08224 8.29297C4.12422 8.2558 4.16621 8.21864 4.20947 8.18034C4.76899 7.68576 5.36983 7.24841 6.01925 6.87926C6.10489 6.83024 6.18967 6.77991 6.27448 6.72948C7.85391 5.80515 9.80686 5.19922 11.6447 5.19922C11.6447 3.48348 11.6447 1.76773 11.6447 0Z"
                          fill="#585858"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_995_1878">
                          <rect width="22" height="22" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </div>
              </div>
            )}

            {pathname == webPaths?.MyAssets && (
              <div class="d-flex align-items-center gap-3 ct_mt_20">
                <a data-bs-target="#mobileAppModal" data-bs-toggle="modal">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.4167 10.0833H4.58333C3.57081 10.0833 2.75 10.9042 2.75 11.9167V18.3333C2.75 19.3459 3.57081 20.1667 4.58333 20.1667H17.4167C18.4292 20.1667 19.25 19.3459 19.25 18.3333V11.9167C19.25 10.9042 18.4292 10.0833 17.4167 10.0833Z"
                      stroke="#364153"
                      stroke-width="1.83333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.4165 10.0833V6.41668C6.4165 5.2011 6.89939 4.03531 7.75893 3.17577C8.61847 2.31623 9.78426 1.83334 10.9998 1.83334C12.2154 1.83334 13.3812 2.31623 14.2407 3.17577C15.1003 4.03531 15.5832 5.2011 15.5832 6.41668V10.0833"
                      stroke="#364153"
                      stroke-width="1.83333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>

                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/assets-detail/${data?.id}`, {
                      state: { from: pathname },
                    });
                  }}
                >
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.8903 11.319C1.81391 11.1132 1.81391 10.8868 1.8903 10.681C2.63436 8.87686 3.89736 7.33428 5.51918 6.24882C7.14099 5.16336 9.04859 4.58389 11.0001 4.58389C12.9517 4.58389 14.8593 5.16336 16.4811 6.24882C18.1029 7.33428 19.3659 8.87686 20.11 10.681C20.1864 10.8868 20.1864 11.1132 20.11 11.319C19.3659 13.1231 18.1029 14.6657 16.4811 15.7512C14.8593 16.8366 12.9517 17.4161 11.0001 17.4161C9.04859 17.4161 7.14099 16.8366 5.51918 15.7512C3.89736 14.6657 2.63436 13.1231 1.8903 11.319Z"
                      stroke="#364153"
                      stroke-width="1.83333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11 13.75C12.5188 13.75 13.75 12.5188 13.75 11C13.75 9.48122 12.5188 8.25 11 8.25C9.48122 8.25 8.25 9.48122 8.25 11C8.25 12.5188 9.48122 13.75 11 13.75Z"
                      stroke="#364153"
                      stroke-width="1.83333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
                <a data-bs-target="#mobileAppModal" data-bs-toggle="modal">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.4096 6.24436C19.8943 5.75983 20.1666 5.10262 20.1667 4.41731C20.1667 3.73199 19.8946 3.07472 19.4101 2.59007C18.9255 2.10542 18.2683 1.83309 17.583 1.83301C16.8977 1.83292 16.2404 2.10508 15.7558 2.58961L3.52194 14.8262C3.3091 15.0384 3.15171 15.2997 3.0636 15.587L1.85269 19.5764C1.829 19.6556 1.82721 19.7398 1.84751 19.8201C1.86781 19.9003 1.90945 19.9735 1.968 20.0319C2.02655 20.0904 2.09984 20.1319 2.18008 20.1521C2.26032 20.1723 2.34453 20.1703 2.42377 20.1465L6.41402 18.9365C6.70109 18.8492 6.96234 18.6928 7.17485 18.4809L19.4096 6.24436Z"
                      stroke="#364153"
                      stroke-width="1.83333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
                <a data-bs-toggle="modal" data-bs-target="#mobileAppModal">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.1665 10.0833V15.5833"
                      stroke="#364153"
                      stroke-width="1.83333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.8335 10.0833V15.5833"
                      stroke="#364153"
                      stroke-width="1.83333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.4168 5.5V18.3333C17.4168 18.8196 17.2237 19.2859 16.8799 19.6297C16.536 19.9735 16.0697 20.1667 15.5835 20.1667H6.41683C5.9306 20.1667 5.46428 19.9735 5.12047 19.6297C4.77665 19.2859 4.5835 18.8196 4.5835 18.3333V5.5"
                      stroke="#364153"
                      stroke-width="1.83333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2.75 5.5H19.25"
                      stroke="#364153"
                      stroke-width="1.83333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.3335 5.50001V3.66668C7.3335 3.18045 7.52665 2.71413 7.87047 2.37031C8.21428 2.0265 8.6806 1.83334 9.16683 1.83334H12.8335C13.3197 1.83334 13.786 2.0265 14.1299 2.37031C14.4737 2.71413 14.6668 3.18045 14.6668 3.66668V5.50001"
                      stroke="#364153"
                      stroke-width="1.83333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>

                <a
                  class=" d-flex align-items-center"
                  data-bs-target="#mobileAppModal"
                  data-bs-toggle="modal"
                  style={{ color: "#364153" }}
                >
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_995_1718)">
                      <path
                        d="M11.6444 0C11.7737 0.0646513 11.8589 0.114095 11.9668 0.202927C11.9949 0.225858 12.0229 0.248789 12.0518 0.272415C12.096 0.309055 12.096 0.309055 12.1412 0.346436C12.172 0.371693 12.2028 0.396951 12.2345 0.422974C12.3244 0.496694 12.4141 0.570605 12.5038 0.644531C12.5825 0.709019 12.6613 0.773477 12.7401 0.837891C12.7772 0.868244 12.8142 0.898597 12.8524 0.929871C13.1224 1.15052 13.3932 1.37007 13.6639 1.58984C14.0095 1.87039 14.3549 2.15103 14.6992 2.43311C14.8551 2.56055 15.0115 2.68751 15.1678 2.81445C15.3988 3.00194 15.6293 3.18991 15.8594 3.37842C16.0153 3.50586 16.1716 3.63282 16.328 3.75977C16.5216 3.91698 16.7151 4.07435 16.9081 4.23242C17.2152 4.48403 17.5236 4.73411 17.8319 4.98438C18.1774 5.26492 18.5229 5.54556 18.8672 5.82764C19.0231 5.95508 19.1794 6.08204 19.3358 6.20898C19.5294 6.3662 19.7229 6.52357 19.9159 6.68164C20.223 6.93325 20.5315 7.18332 20.8397 7.43359C21.227 7.74802 21.6141 8.06262 21.9999 8.37891C21.9337 8.56218 21.7959 8.65344 21.6454 8.76562C21.4248 8.93413 21.2104 9.10736 21.0008 9.28931C20.8035 9.46011 20.6042 9.62691 20.3994 9.78882C20.2454 9.9112 20.0927 10.0353 19.94 10.1594C19.8954 10.1957 19.8954 10.1957 19.8499 10.2327C19.6065 10.4307 19.3636 10.6293 19.121 10.8281C19.0422 10.8926 18.9634 10.957 18.8846 11.0215C18.8456 11.0534 18.8066 11.0853 18.7665 11.1182C18.412 11.4082 18.412 11.4082 18.293 11.5056C18.217 11.5677 18.141 11.63 18.065 11.6922C17.8004 11.9089 17.5351 12.1247 17.2696 12.3403C17.0269 12.5375 16.7847 12.7354 16.5428 12.9336C16.4641 12.9981 16.3853 13.0625 16.3065 13.127C16.2675 13.1589 16.2285 13.1908 16.1883 13.2236C15.3612 13.9004 15.3612 13.9004 15.2422 13.9977C15.1662 14.0599 15.0902 14.1221 15.0143 14.1844C14.7497 14.4011 14.4844 14.6169 14.2188 14.8325C13.9761 15.0297 13.7339 15.2276 13.492 15.4258C13.4133 15.4902 13.3345 15.5547 13.2557 15.6191C13.2167 15.651 13.1777 15.6829 13.1376 15.7158C12.7831 16.0059 12.7831 16.0059 12.6652 16.1022C12.5853 16.1677 12.5054 16.2333 12.4256 16.2989C11.7102 16.8867 11.7102 16.8867 11.6444 16.8867C11.6444 15.171 11.6444 13.4552 11.6444 11.6875C9.09398 12.0166 6.92799 12.7276 4.8983 14.3086C4.85742 14.3402 4.81654 14.3718 4.77443 14.4044C3.09923 15.7371 2.01521 17.472 1.17882 19.4138C1.14124 19.5006 1.10365 19.5873 1.06604 19.6741C0.887199 20.0871 0.709762 20.5007 0.534117 20.915C0.504189 20.9855 0.47426 21.0559 0.44433 21.1264C0.388833 21.2571 0.333745 21.3879 0.278896 21.5188C0.254265 21.577 0.229624 21.6352 0.20497 21.6933C0.183887 21.7435 0.162805 21.7937 0.141083 21.8455C0.0857987 21.957 0.0857987 21.957 -0.000138753 22C-0.00317477 21.3134 -0.00543469 20.6268 -0.00681722 19.9402C-0.00747673 19.6212 -0.00837326 19.3023 -0.00986337 18.9834C-0.0111643 18.7048 -0.0119832 18.4262 -0.012267 18.1476C-0.0124324 18.0006 -0.0128105 17.8537 -0.0137684 17.7067C-0.0192711 16.7547 0.0316286 15.81 0.238875 14.8779C0.249544 14.8292 0.260214 14.7805 0.271206 14.7303C0.47099 13.8618 0.763978 13.0017 1.16002 12.2031C1.18739 12.147 1.18739 12.147 1.21532 12.0897C1.62553 11.254 2.11838 10.4757 2.70689 9.75391C2.72464 9.7318 2.74238 9.70969 2.76067 9.68691C3.04537 9.33397 3.35692 9.00932 3.67637 8.68774C3.73194 8.63158 3.73194 8.63158 3.78863 8.57428C4.04496 8.31919 4.31419 8.0878 4.59752 7.86328C4.64357 7.82591 4.68962 7.78854 4.73566 7.75116C6.52509 6.34426 8.6284 5.54166 10.871 5.24219C10.9057 5.23751 10.9405 5.23283 10.9763 5.228C11.2037 5.19985 11.4117 5.19922 11.6444 5.19922C11.6444 3.48348 11.6444 1.76773 11.6444 0ZM12.9764 2.79297C12.9764 4.01242 12.9764 5.23187 12.9764 6.48828C12.7354 6.48828 12.4943 6.48828 12.246 6.48828C9.12179 6.5346 6.38988 7.83113 4.22137 10.0376C4.03214 10.2334 3.86112 10.4404 3.69517 10.6562C3.67604 10.6805 3.65691 10.7047 3.6372 10.7296C2.45885 12.2212 1.57694 14.1181 1.41783 16.0273C1.44071 15.9987 1.46358 15.97 1.48715 15.9404C1.60932 15.788 1.73239 15.6364 1.85557 15.4849C1.8782 15.457 1.90083 15.4291 1.92414 15.4004C1.97219 15.3413 2.02033 15.2822 2.06853 15.2232C2.12513 15.1535 2.18129 15.0835 2.23713 15.0132C2.46935 14.7235 2.7172 14.4571 2.98082 14.1958C3.01815 14.1581 3.05548 14.1205 3.09395 14.0817C3.35256 13.8238 3.62407 13.5902 3.91002 13.3633C3.96025 13.3223 4.01044 13.2813 4.06058 13.2402C5.76394 11.8763 7.76946 10.9979 9.90416 10.5784C9.96787 10.5658 9.96787 10.5658 10.0329 10.553C11.0068 10.3716 11.9874 10.3607 12.9764 10.3125C12.9764 11.5461 12.9764 12.7798 12.9764 14.0508C13.138 13.9538 13.2685 13.8637 13.4115 13.7446C13.4528 13.7104 13.4941 13.6762 13.5367 13.6409C13.5787 13.606 13.6207 13.5711 13.6639 13.5352C13.7426 13.4706 13.8214 13.4062 13.9003 13.3418C13.9392 13.3099 13.9782 13.278 14.0184 13.2451C14.8456 12.5684 14.8456 12.5684 14.9646 12.471C15.0406 12.4088 15.1165 12.3466 15.1925 12.2844C15.4571 12.0676 15.7224 11.8518 15.9879 11.6362C16.2307 11.4391 16.4728 11.2412 16.7147 11.043C16.7935 10.9785 16.8723 10.9141 16.951 10.8496C16.99 10.8177 17.029 10.7858 17.0692 10.7529C18.369 9.68945 18.369 9.68945 18.488 9.5921C18.564 9.52991 18.64 9.4677 18.7159 9.40546C18.8365 9.30667 18.9572 9.208 19.078 9.10938C19.1063 9.08626 19.1346 9.06314 19.1637 9.03932C19.2568 8.96324 19.35 8.88725 19.4432 8.81128C19.4731 8.78687 19.503 8.76245 19.5337 8.7373C19.576 8.70288 19.576 8.70288 19.6191 8.66777C19.6442 8.64728 19.6694 8.62679 19.6952 8.60568C19.7593 8.55561 19.8267 8.50994 19.8944 8.46484C19.8944 8.43648 19.8944 8.40812 19.8944 8.37891C19.8073 8.30486 19.7197 8.23547 19.6285 8.16675C19.4191 8.00586 19.2138 7.84204 19.0135 7.66992C18.8238 7.50738 18.6307 7.35055 18.4335 7.19727C18.2122 7.02536 17.9972 6.84776 17.7844 6.66553C17.6174 6.52318 17.4466 6.3866 17.2733 6.25195C17.0482 6.07703 16.8291 5.89645 16.6123 5.71134C16.4406 5.56485 16.2658 5.42291 16.089 5.28264C15.9399 5.16394 15.7928 5.04292 15.6455 4.9221C15.4867 4.79197 15.3272 4.66261 15.1678 4.5332C14.9742 4.37599 14.7807 4.21862 14.5878 4.06055C14.2805 3.80899 13.9725 3.55842 13.6639 3.30859C13.6332 3.28372 13.6025 3.25885 13.5709 3.23323C13.4811 3.16065 13.3913 3.08823 13.3014 3.01587C13.2737 2.99345 13.246 2.97102 13.2174 2.94792C13.1089 2.8415 13.1089 2.8415 12.9764 2.79297Z"
                        fill="#364153"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_995_1718">
                        <rect width="22" height="22" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </div>
            )}
          </div>
        </figure>
      </div>
    </>
  );
};

export default AssetCard;
